<app-breadcrumb [master]="'Narzędzia'" [parentName]="'Formularze'" [name]="'Dodaj'"
                *ngIf="!dynamicForm"></app-breadcrumb>
<div class="add-dynamic-form-container" fxLayout="column" fxLayoutGap="15px" [formGroup]="addFormForm">
  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest" [disabled]="!addFormForm.valid || processingRequest" mat-stroked-button
            color="primary">
      <mat-icon>save</mat-icon>
      <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn">
      <mat-icon>cancel</mat-icon>
      <span> Anuluj</span></button>
  </div>
  <div fxLayout="column" fxFlex="100">
    <div fxLayout="row" fxLayoutGap="15px">
      <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100" fxFlex.lt-xl="100">
        <div fxLayout="row">
          <h3>Dodaj formularz</h3>
        </div>
        <div fxLayout="row" fxLayoutGap="15px" fxFlex="100">
          <mat-form-field fxFlex="100">
            <mat-label>Nazwa formularza</mat-label>
            <input formControlName="name" matInput [required]="true" [formControl]="nameControl">
            <mat-error></mat-error>
          </mat-form-field>
        </div>
        <div fxLayout="row" fxFlex="100">
          <mat-slide-toggle fxFlex="33" color="accent" [formControl]="activeControl"> Aktywna</mat-slide-toggle>
          <mat-slide-toggle fxFlex="33" color="accent" [formControl]="activeMailSendControl"> Wysyłka maili do
            administratora
          </mat-slide-toggle>
          <mat-slide-toggle fxFlex="33" color="accent" [formControl]="structureSendControl"> Przypisywanie struktury
          </mat-slide-toggle>
        </div>
        <div fxLayout="row" fxFlex="100">
          <mat-slide-toggle fxFlex="33" color="accent" [formControl]="ownerSendControl"> Wysyłka maili do Partnera
          </mat-slide-toggle>
          <mat-slide-toggle fxFlex="33" color="accent" [formControl]="serviceTimeControl"> Czas obsługi
          </mat-slide-toggle>
          <mat-slide-toggle fxFlex="33" color="accent" [formControl]="creatingAccountControl"> Automatyczne tworzenie
            kont w ASF360
          </mat-slide-toggle>
        </div>
        <div fxLayout="row" fxFlex="100">
          <mat-slide-toggle fxFlex="33" color="accent" [formControl]="emailReturnToSenderControl"> Wysyłka zwrotna do
            nadawcy
          </mat-slide-toggle>
        </div>

        <div fxLayout="row" fxFlex="100">
          <mat-form-field fxFlex="100">
            <mat-label>Link do formularza </mat-label>
            <input name="Link do formularza"  matInput [formControl]="linkToFormControl" [required]="false" >
          </mat-form-field>
        </div>

      </mat-card>
    </div>
  </div>
  <div fxLayout="row"  fxFlex="100" fxLayoutGap="15px">
    <mat-card fxLayout="column" fxFlex="100" fxLayoutGap="15px" >
      <h3>
        Uprawnieni użytkownicy
      </h3>
      <app-dict-users
        class="user-list-filter"
        label="Użytkownik"
        [multiple]="true"
        [userFormsPermission]="true"
        [contentEditable]="true"
        [userPageSize] = 999
        [userPermissionsEditable]="false"
        [formControl]="permissionUserControl"
        [filterDynamicForm]="true"
      ></app-dict-users>
    </mat-card>
  </div>
  <mat-card fxFlex.lt-md="100" fxLayout="column" *ngIf="mailAccept">
    <div fxLayout="row">
      <h3 fxFlex="100"> Lista adresów mailowych administratora </h3>
      <button fxLayoutAlign="end end" class="list-add-button" (click)="openModal()" mat-icon-button color="accent">
        <mat-icon>add_box</mat-icon>
      </button>
    </div>
    <div fxLayout="row wrap" fxFlex="100">
      <div fxLayout="row" fxFlex="33" *ngFor="let formGroup of emailToFormArray; index as i">
        <mat-form-field [formGroup]="formGroup" fxFlex="90">
          <mat-label>Adres mailowy</mat-label>
          <input matInput placeholder="adres@mail.pl" formControlName="emailAddressList" [required]="true">
        </mat-form-field>
        <div class="list-remove-button" fxFlex="10px">
          <button (click)="removeMail(i)" mat-icon-button color="warn">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </mat-card>
  <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100" *ngIf="ownerSend ">
    <div fxLayout="row" fxFlex="100">
      <h3> Szablon email zwrotnego do Partnera  </h3>
    </div>

    <mat-form-field fxFlex="100">
      <mat-label>Tytułu maila </mat-label>
      <input  matInput [formControl]="emailTitleControl" [required]="true" >
    </mat-form-field>

    <div fxLayout="row" fxFlex="100">
      <h4>Zmienne do tabeli: {{temptable}} </h4>
    </div>
    <div fxLayout="row">
      <angular-editor [config]="editorConfig" [formControl]="contentEmailControl" fxFlex="100"></angular-editor>
    </div>

  </mat-card>
  <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100" *ngIf="emailReturnToSenderControl.value">
    <div fxLayout="row" fxFlex="100">
      <h3> Szablon email zwrotnego do nadawcy </h3>
    </div>
    <mat-form-field fxFlex="100">
      <mat-label>Tytułu maila </mat-label>
      <input  matInput [formControl]="subjectEmailToReturnToSenderControl" [required]="true" >
    </mat-form-field>
    <div fxLayout="row">
      <angular-editor [config]="editorConfig" [formControl]="contentEmailToReturnToSenderControl" fxFlex="100"></angular-editor>
    </div>
  </mat-card>

  <div fxLayout="row"  fxFlex="100" fxLayoutGap="15px">
  <mat-card fxLayout="column"  fxLayoutGap="15px"  fxFlex="50"  *ngIf="structureAccept">
    <h3>
      Przypisanie struktury
    </h3>
    <mat-form-field fxFlex="100">
      <mat-label>Przykładowy link </mat-label>
      <input name="link"  matInput [formControl]="linkControl" [required]="true" >
    </mat-form-field>
  </mat-card>
  <mat-card fxLayout="column"  fxLayoutGap="15px"  fxFlex="50"  *ngIf="serviceTimeAccept">
    <h3>
      Czas obsługi
    </h3>
    <mat-form-field fxFlex="100">
      <mat-label>Wprowadź czas obsługi (w godzinach) </mat-label>
      <input name="serviceTime" type="number" formControlName="serviceTime" min="0" step="1" matInput oninput="this.value = Math.round(this.value);"  [formControl]="serviceTimeInput" [required]="serviceTimeAccept"  >    </mat-form-field>
</mat-card>
<!--    <mat-card  fxLayout="column" fxLayoutGap="15px" fxFlex="50">-->
<!--      <div fxLayout="row">-->
<!--        <h3 fxFlex="100"> Lista użytkowników z uprawnieniami </h3>-->
<!--      </div>-->
<!--      <div fxLayout="column" fxFlex="100">-->
<!--        <div fxLayout="row" fxFlex="33" fxLayoutGap="15px" *ngFor="let name of namesArray; index as i">-->
<!--        <span>{{name}}</span>-->
<!--        </div>-->
<!--      </div>-->
<!--    </mat-card>-->
  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="save()"   [class.spinner]="processingRequest" [disabled]="!addFormForm.valid || processingRequest"  mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
